import React from 'react'
import {Text, Input, Divider} from './styled'

import {
    Button,
  } from '@material-ui/core';

export default ({ text }) => {

  //const matches = useMediaQuery('(min-width:1000px)');
  //if(!!matches) {
    return (
      <form method="post" action="http://adm.cityconnect.com.br/login" id="os-form">
        <div style={{ display: 'flex', flexDirection: 'row'}}>
            <Text>{ text.getOsSystem() }</Text>

          <Divider width="1vw" />
          <Input name="email" placeholder={ text.getUsername() } />

          <Divider width="1vw" />
          <Input type="password" name="password" placeholder={ text.getPassword() } />

          <Divider width="1vw" />
          <Button color="#58b711" type="submit">
            <Text size="14px"> { text.getLogin() } </Text>
          </Button>
        </div>
      </form>
    )
  //}
}